import { createDnd } from '~/astra'
import { Location, PractitionerScheduleLocationCell, PractitionerScheduleStatusCell } from '~/storm'

export type PractitionerLocationActivity = PractitionerScheduleLocationCell

/** Status chips also carry the locations that move with them. */
export type PractitionerStatusActivity = PractitionerScheduleStatusCell & {
    locations: Location[]
}

export type PractitionerActivity = PractitionerLocationActivity | PractitionerStatusActivity

// Location chips move between the Practitioners and Locations tables.
export const PractitionerActivityDnd = createDnd<PractitionerActivity>({ name: 'practitioner activity' })
